import { createSlice } from '@reduxjs/toolkit';
import { AppThunk, RootState } from './index';
import { Api } from '../services/Api';
import { UserService } from '../services/UserService';
import { NposCreateResponse } from '../types/npos';
import { openMenu, setIsRegistered, setModalSignInUp } from './AppSlice';
import { modalTypeEnum } from '../types/modal';
import { setAccessTokenLocally, setRefreshTokenForEncryption } from './EncryptionSlice';
import { setLoaderStatus, setModalLoaderStatus } from './LoaderSlice';
import { setModalErrorMessage } from './NotificationSlice';

const initialState = {
    nposStatus: false,
    nposList: [],
    nposInvalidateStatus: null,
    nposInvalidateId: '',
    loadingStatus: false,
    invalidateMessage: {
        message: '',
        code: 0
    }
};

const NposSlice = createSlice({
    name: 'npos' ,
    initialState,
    reducers: {
        setNposStatus: (state, action) => {
            state.nposStatus = action.payload
        },
        setNposList: (state, action) => {
            state.nposList = action.payload
        },
        setInvalidateNposStatus: (state, action) => {
            state.nposInvalidateStatus = action.payload
        },
        setInvalidateNposLoadingStatus: (state, action) => {
            state.loadingStatus = action.payload
        },
        setInvalidateNposId: (state, action) => {
            state.nposInvalidateId = action.payload
        },
        setInvalidateNposMessage: (state, action) => {
            state.invalidateMessage = action.payload
        },
    }
});

// EXPORT DEFAULT
export const { setNposStatus,setNposList,setInvalidateNposStatus,setInvalidateNposId,setInvalidateNposLoadingStatus,setInvalidateNposMessage } = NposSlice.actions;
export default NposSlice.reducer;

export const createNpos = (url:string): AppThunk<Promise<void>> => async (dispatch, getState) => {

    const token = url.split("invite=")[1];
    
    try {
        UserService.createNposStation(token)
        .then( (nposCreationResponse: NposCreateResponse) => {
    
            if (nposCreationResponse.data) {
    
                dispatch( setIsRegistered(true));
                const state = getState();
    
                if (!state) throw new Error('State not present');
    
                localStorage.setItem('npos', nposCreationResponse.data.npos_id);
                localStorage.setItem('isnpos', 'true');
                Api.setToken(nposCreationResponse.data.token);
    
                dispatch( setRefreshTokenForEncryption(nposCreationResponse.data.refresh_token));
                dispatch( setAccessTokenLocally(nposCreationResponse.data.token));

                dispatch( setModalSignInUp(modalTypeEnum.deviceLogin));
    
                let userInfoData : any = state.user.userInfo;
                localStorage.setItem('wallet',userInfoData?.user_id)

                dispatch( setLoaderStatus(false));
                return;
    
            } else {
                dispatch(setModalErrorMessage('Erro na Criação de nPOS'));
                dispatch(setModalSignInUp(modalTypeEnum.serverError));
                dispatch( setLoaderStatus(false));
                return;
            }
    
        }, err => {
            console.error('error')
            console.error(err)
            dispatch(setModalErrorMessage(err.response.data.message || 'Error Getting Message'));
            dispatch(setModalSignInUp(modalTypeEnum.serverError));
        })
        .catch( err => {
            console.dir('catch 1')
            console.dir(err);
            dispatch(setModalErrorMessage(err.response.data.message || 'Error Getting Message'));
            dispatch(setModalSignInUp(modalTypeEnum.serverError));
        })

    } catch (err: any) {
        console.dir('catch 2')
        console.dir(err);
        dispatch(setModalErrorMessage(err.response.data.message || 'Error Getting Message'));
        dispatch(setModalSignInUp(modalTypeEnum.serverError));
    }
}

// CRUD npos
export const getNposList = (state: RootState) => state.npos.nposList
export const getNposInvalidadeId = (state: RootState) => state.npos.nposInvalidateId
export const getInvalidateNposLoadingStatus = (state: RootState) => state.npos.loadingStatus
export const getInvalidateNposStatus = (state: RootState) => state.npos.nposInvalidateStatus
export const getInvalidateNposMessage = (state: RootState) => state.npos.invalidateMessage

export const fetchNposList = (): AppThunk<Promise<void>> => async (dispatch) => {

    const list = await UserService.fetchNposList();

    if (list) {
        if(list.data) {
            dispatch(setNposList(list.data))
        } else {
            dispatch(setModalSignInUp(modalTypeEnum.serverError));
        }
    } else {
        dispatch(setModalSignInUp(modalTypeEnum.serverError));
    }

}

export const invalidateNpos = (nposId:string): AppThunk<Promise<void>> => async (dispatch) => {
    dispatch(setInvalidateNposLoadingStatus(true));

    const invalidateResponse = await UserService.invalidateNposList(nposId);
    if (invalidateResponse) {
        dispatch(setInvalidateNposMessage({ code: 200, message: "NPoS revogado com sucesso."}))
    } else {
        dispatch(setInvalidateNposMessage({ code: invalidateResponse.code , message: invalidateResponse.message}))
    }

    dispatch(setInvalidateNposId(``));
    dispatch(setModalLoaderStatus(false));
    dispatch(setInvalidateNposLoadingStatus(false));
    dispatch(setInvalidateNposStatus(true));

}
